/** Hook for managing individual task data operations. */
// @ts-check
import { deleteTasks } from '@/services/taskMutations';
import { useProjectLimitGuard } from '@/features/wall';
import {
  executeTaskUpdateDetails,
  executeUpdateTaskDuration,
} from '@/features/tasks/utils/mutations/taskDataUtils.js';

const useTaskData = () => {
  const { guardProjects } = useProjectLimitGuard();

  /**
   * @param {string} taskId
   * @param {UpdateTask} taskData
   * @param {string} userId
   * @returns {Promise<void>}
   */
  const updateTaskDetails = async (taskId, taskData, userId) => {
    const projects =
      taskData.projects ??
      (typeof taskData.title === 'object' && taskData.title !== null
        ? taskData.title.projects
        : undefined);
    if (projects?.length && !guardProjects(projects)) {
      return;
    }
    return executeTaskUpdateDetails(taskId, taskData, userId);
  };

  /**
   * @param {string} taskId
   * @param {number} newDuration
   * @returns {Promise<void>}
   */
  const updateTaskDuration = async (taskId, newDuration) => {
    return executeUpdateTaskDuration(taskId, newDuration);
  };

  /**
   * @param {string[]} taskIds
   * @returns {Promise<void>}
   */
  const handleDeleteTask = async (taskIds) => {
    try {
      await deleteTasks(taskIds);
    } catch (error) {
      console.error('Error while deleting task:', error);
    }
  };

  return {
    updateTaskDetails,
    handleDeleteTask,
    updateTaskDuration,
  };
};

export default useTaskData;
